import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';

class ProductGallery {
  public static fetch(sku: string): RequestConfigType {
    return RequestConfig.get(`/products/${sku}/gallery`);
  }
}

export { ProductGallery };
